<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-streetMap-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-streetMap-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.44176706827309;"
    data-aspect-ratio="0.442"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-streetMap-xs-img"
      class="g-streetMap-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/streetMap-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-Locator g-aiAbs g-aiPointText"
      style="top:6.1577%;margin-top:-14px;left:74.1048%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle0">Minnesota</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:19.3493%;margin-top:-11.5px;left:47.6332%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle1">Minneapolis</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:26.846%;margin-top:-8.5px;left:47.9131%;margin-left:-54.5px;width:109px;"
    >
      <p class="g-pstyle2">Site of shooting</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-yellowtext g-aiAbs"
      style="top:65.0602%;left:65.2876%;margin-left:-20.9091%;width:41.8182%;"
    >
      <p class="g-pstyle3">Location of fatal</p>
      <p class="g-pstyle3">ICE shooting</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:82.9315%;margin-top:-7.5px;left:74.528%;width:52px;"
    >
      <p class="g-pstyle4">North</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-streetMap-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.1038961038961;"
    data-aspect-ratio="1.104"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-streetMap-sm-img"
      class="g-streetMap-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/streetMap-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-Locator_copy_2 g-aiAbs g-aiPointText"
      style="top:9.4062%;margin-top:-11.5px;left:86.3289%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle0">Minnesota</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:26.9566%;margin-top:-11.5px;left:72.3901%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle1">Minneapolis</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:36.255%;margin-top:-7.5px;left:72.9308%;margin-left:-51px;width:102px;"
    >
      <p class="g-pstyle2">Site of shooting</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-yellowtext g-aiAbs"
      style="top:43.5065%;left:28.9116%;margin-left:-13.5294%;width:27.0588%;"
    >
      <p class="g-pstyle3">Location of fatal</p>
      <p class="g-pstyle3">ICE shooting</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:47.5104%;margin-top:-7.5px;left:3.5181%;width:52px;"
    >
      <p class="g-pstyle4">North</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-streetMap-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.42857142857143;"
    data-aspect-ratio="1.429"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-streetMap-md-img"
      class="g-streetMap-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/streetMap-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-Locator_copy g-aiAbs g-aiPointText"
      style="top:9.4062%;margin-top:-11.5px;left:90.9511%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle0">Minnesota</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:26.9566%;margin-top:-11.5px;left:80.1802%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle1">Minneapolis</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:36.255%;margin-top:-7.5px;left:80.5981%;margin-left:-51px;width:102px;"
    >
      <p class="g-pstyle2">Site of shooting</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-yellowtext g-aiAbs"
      style="top:43.5065%;left:46.5832%;margin-left:-10.4545%;width:20.9091%;"
    >
      <p class="g-pstyle3">Location of fatal</p>
      <p class="g-pstyle3">ICE shooting</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:73.9173%;margin-top:-7.5px;left:81.2034%;width:52px;"
    >
      <p class="g-pstyle4">North</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-streetMap-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 1.64021164021164;"
    data-aspect-ratio="1.64"
    data-min-width="930"
  >
    <div
      id="g-streetMap-lg-img"
      class="g-streetMap-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/streetMap-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-Locator g-aiAbs g-aiPointText"
      style="top:8.818%;margin-top:-14px;left:90.062%;width:75px;"
    >
      <p class="g-pstyle0">Minnesota</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:26.293%;margin-top:-14.1px;left:83.4164%;margin-left:-55px;width:110px;"
    >
      <p class="g-pstyle1">Minneapolis</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:30.7167%;margin-top:-10.2px;left:4.7875%;width:61px;"
    >
      <p class="g-pstyle2">North</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:35.9931%;margin-top:-9.1px;left:83.5916%;margin-left:-57.5px;width:115px;"
    >
      <p class="g-pstyle3">Site of shooting</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-yellowtext g-aiAbs"
      style="top:43.9153%;left:47.0285%;margin-left:-6.0753%;width:12.1505%;"
    >
      <p class="g-pstyle4">Location of fatal ICE shooting</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-08 13:40 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-08 13:40 -->
<!-- ai file: streetMap.ai -->
<style lang="scss">
  #g-streetMap-box {
    container-type: inline-size;
    container-name: g-streetMap-box;
  }
  #g-streetMap-box,
  #g-streetMap-box .g-artboard {
    margin: 0 auto;
  }
  #g-streetMap-box p {
    margin: 0;
  }
  #g-streetMap-box .g-aiAbs {
    position: absolute;
  }
  #g-streetMap-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-streetMap-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-streetMap-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-streetMap-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-streetMap-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-streetMap-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-streetMap-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-streetMap-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-streetMap-lg {
        display: block !important;
      }
    }
  }
  #g-streetMap-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-streetMap-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 212, 48);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-streetMap-xs .g-pstyle0 {
    font-weight: 400;
    line-height: 27px;
    height: 27px;
    font-size: 12px;
    text-align: center;
    color: rgb(58, 58, 58);
  }
  #g-streetMap-xs .g-pstyle1 {
    font-weight: 500;
    line-height: 22px;
    height: 22px;
    letter-spacing: 0.1em;
    font-size: 13px;
    text-align: center;
    color: rgb(102, 102, 102);
  }
  #g-streetMap-xs .g-pstyle2 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
    color: rgb(51, 51, 51);
  }
  #g-streetMap-xs .g-pstyle3 {
    font-weight: 700;
    text-align: center;
  }
  #g-streetMap-xs .g-pstyle4 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    color: rgb(255, 255, 255);
  }
  #g-streetMap-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-streetMap-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 212, 48);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-streetMap-sm .g-pstyle0 {
    font-weight: 400;
    line-height: 22px;
    height: 22px;
    font-size: 11px;
    text-align: center;
    color: rgb(58, 58, 58);
  }
  #g-streetMap-sm .g-pstyle1 {
    font-weight: 500;
    line-height: 22px;
    height: 22px;
    letter-spacing: 0.1em;
    font-size: 13px;
    text-align: center;
    color: rgb(102, 102, 102);
  }
  #g-streetMap-sm .g-pstyle2 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(51, 51, 51);
  }
  #g-streetMap-sm .g-pstyle3 {
    font-weight: 700;
    text-align: center;
  }
  #g-streetMap-sm .g-pstyle4 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    color: rgb(255, 255, 255);
  }
  #g-streetMap-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-streetMap-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 212, 48);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-streetMap-md .g-pstyle0 {
    font-weight: 400;
    line-height: 22px;
    height: 22px;
    font-size: 11px;
    text-align: center;
    color: rgb(58, 58, 58);
  }
  #g-streetMap-md .g-pstyle1 {
    font-weight: 500;
    line-height: 22px;
    height: 22px;
    letter-spacing: 0.1em;
    font-size: 13px;
    text-align: center;
    color: rgb(102, 102, 102);
  }
  #g-streetMap-md .g-pstyle2 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(51, 51, 51);
  }
  #g-streetMap-md .g-pstyle3 {
    font-weight: 700;
    text-align: center;
  }
  #g-streetMap-md .g-pstyle4 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    color: rgb(255, 255, 255);
  }
  #g-streetMap-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-streetMap-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 212, 48);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-streetMap-lg .g-pstyle0 {
    font-weight: 400;
    line-height: 27px;
    height: 27px;
    font-size: 12px;
    color: rgb(58, 58, 58);
  }
  #g-streetMap-lg .g-pstyle1 {
    font-weight: 500;
    line-height: 27px;
    height: 27px;
    letter-spacing: 0.1em;
    font-size: 14px;
    text-align: center;
    color: rgb(102, 102, 102);
  }
  #g-streetMap-lg .g-pstyle2 {
    font-weight: 400;
    height: 19px;
    color: rgb(255, 255, 255);
  }
  #g-streetMap-lg .g-pstyle3 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
    color: rgb(51, 51, 51);
  }
  #g-streetMap-lg .g-pstyle4 {
    font-weight: 700;
    text-align: center;
  }

  /* Custom CSS */
  @mixin shadow-roquefort($clr) {
    text-shadow:
      0 0 2px rgba($clr, 1),
      0 0 2px rgba($clr, 0.8),
      0 0 2px rgba($clr, 0.5);
  }

  @mixin shadow-taleggio($clr) {
    text-shadow:
      0px 0px 5px rgba($clr, 1),
      0px 0px 5px rgba($clr, 1);
  }

  @mixin shadow-gouda($clr) {
    text-shadow:
      1px 1px 1px rgba($clr, 0.9),
      1px -1px 1px rgba($clr, 0.9),
      -1px 1px 1px rgba($clr, 0.9),
      -1px -1px 1px rgba($clr, 0.9);
  }
  .g-yellowtext {
    @include shadow-roquefort(#000000);
    @include shadow-taleggio(#000000);
  }
  .g-whiteshadow {
    @include shadow-gouda(#ffffff);
  }
</style>
